import gql from 'graphql-tag';
import OFFER_ITEM_FRAGMENT from './item';

export default gql`
  fragment OfferOrderFragment on OfferOrder {
    id
    orders_wrapper_id
    orders_wrapper_number
    subtotal
    delivery_fee
    total_adjustments
    total_price
    total_amount_due
    total_cashback
    currency_code
    min_expected_delivery
    max_expected_delivery
    humanized_min_expected_delivery
    humanized_max_expected_delivery
    humanized_placed_at
    items {
      ...OfferItemFragment
    }
    shipping_method {
      id
      shipping_type {
        id
        type {
          name
          name_ar
        }
      }
      ship_address {
        id
        street_number
        apartment_floor
        full_name
        phone_number {
          intl_number_with_leading_zeros
        }
        city {
          id
          name
          name_ar
          country {
            name
          }
        }
      }
    }
    state {
      id
      name
      name_ar
    }
    payment_methods {
      id
      title
      state {
        name
      }
      humanized_created_at
      in_currency_amount
    }
  }
  ${OFFER_ITEM_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./app/containers/Lite/gql/f/order.js